import { Component, OnInit } from '@angular/core';
import { FirebaseHelperService } from '../../core/firebase/firebase-helper.service';
import { SellerApiService } from '../../seller/service/seller-api.service';
import { MessageModel } from '../../core/firebase/models/message.model';
import { CognitoUtil } from '../../authentication/service/cognito.service';

@Component({
  selector: 'app-chat-test',
  templateUrl: './chat-test.component.html',
  styleUrls: ['./chat-test.component.scss']
})
export class ChatTestComponent implements OnInit {

  public currentUserId: number = 1;
  public currentSellerId: number;
  public buyeruserId: number;
  public currentUserProfilePic: string;
  public currentUserName: string = "dilushika@ascentic.se";
  public selectedProjectId: number = null;
  public selectedSellerId: number = null;
  public selectedBuyerId: number = null;
  public messageToSend: string = '';
  public agreedProjects: any[];
  public messages: any[];
  workeruserid: number;
  internalchat: boolean;

    // Co Workers charts
    workerlist: Array<any> = [];
    workerInformation: any = {};

  constructor(
    private sellerService: SellerApiService, private cognitoService: CognitoUtil,
    private firebaseHelperService: FirebaseHelperService,
  ) {

  }

  ngOnInit() {
    this.currentUserName = localStorage.getItem('verificationUserName');
   // tslint:disable-next-line:prefer-const
   let userDetails = this.cognitoService.getCurrentUser();
   this.currentUserName = userDetails.username;

    //  get current user id and  current user profile picture
    if (this.currentUserName != null) {
      this.sellerService.getProfileDetails(this.currentUserName).subscribe(res => {
        if (res != null) {
          this.currentUserId = res.user_id;
          this.currentSellerId = res.seller_id;
          this.currentUserProfilePic = res.image_url;
        }
      }, err => {
        console.log(err);
      });
    }
    this.getAgreedProjects();
  }


  private getAgreedProjects() {
    this.sellerService.getAllAgreedProjects(this.currentUserName).finally(() => {
    }).subscribe(res => {
      if (res != null) {
        this.agreedProjects = res;
      }

      if (this.agreedProjects.length > 0 && this.agreedProjects[0].project_id != null) {
        this.selectedProjectId = this.agreedProjects[0].project_id;
        this.selectedSellerId = this.currentSellerId;
        this.selectedBuyerId = this.agreedProjects[0].buyer_id;
        this.firebaseHelperService.filterMessages(this.selectedProjectId, this.selectedSellerId,
          this.selectedBuyerId, '', 100000); // apply filter
        this.firebaseHelperService.messages.subscribe((val) => { this.messages = val }); // load messages by subscribing
      }
    }, err => {
      console.log(err);
    });
  }

  getLatestMessages(workeruser): void {
    this.messages = [];
    this.workeruserid = workeruser;
     // tslint:disable-next-line:max-line-length
     this.firebaseHelperService.filterMessagesByCoChat(this.selectedProjectId, this.selectedSellerId, this.selectedBuyerId, '', 10000); // apply filter
     this.firebaseHelperService.messages.subscribe((val) => { this.messages = val }); // load messages by subscribing

  }
  callInputCheckBoxChanges(): void {
    this.messages = [];
    if (!this.internalchat) {
    }
  }

  getAllWorkersList(projectid: number): void {
    this.workerlist = [];
    this.sellerService.getWorkersByprojectId(projectid).subscribe(res => {
      if (res != null) {
        this.workerlist = res;
        if (this.workerlist.length > 0) {
          this.workerInformation = this.workerlist[0];
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // get messages when project selected
  public projectSelected(projectId: number, sellerId: number, buyerId: number) {
    this.selectedProjectId = projectId;
    this.selectedSellerId = this.currentSellerId;
    this.selectedBuyerId = buyerId;
    this.getBuyerInformation(this.selectedBuyerId);
    this.getAllWorkersList(projectId);
    // tslint:disable-next-line:max-line-length
    this.firebaseHelperService.filterMessages(this.selectedProjectId, this.selectedSellerId, this.selectedBuyerId, '', 10000); // apply filter
    this.firebaseHelperService.messages.subscribe((val) => { this.messages = val }); // load messages by subscribing
  }

  getBuyerInformation(buyerid: number): void {
    if (buyerid != null) {
      this.sellerService.getBuyerInformationByBuyerId(buyerid.toString()).subscribe(res => {
        console.log(res);

      }, err => {
        console.log(err);
      });
    }
  }

  // send message
  public sendMessage() {
    if (!this.internalchat) {
      // tslint:disable-next-line:prefer-const
      let newMessage = new MessageModel(26, this.currentUserId, this.messageToSend, '', '', new Date().toUTCString(), 1, '');
      this.firebaseHelperService.sendMessage(this.selectedProjectId, this.selectedSellerId, 26, newMessage);
      this.messageToSend = '';
    } else {
      if (this.workeruserid != null || this.workeruserid !== undefined) {
        // tslint:disable-next-line:prefer-const
        let newMessage = new MessageModel(this.workeruserid, this.currentUserId, this.messageToSend, '', '',
        new Date().toUTCString(), 1, '');
        this.firebaseHelperService.sendMessageToCoWorkers(this.selectedProjectId, this.selectedSellerId, this.workeruserid, newMessage);
        this.messageToSend = '';
      }

    }

  }

  // return thumbnail image to display by attachment url
  public getMessageFileThumbnail(fileUrl: string) {
    // tslint:disable-next-line:prefer-const
    let extension = fileUrl.split('.').splice(-1)[0];

    // determine file type
    switch (extension.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'png':
        return fileUrl;

      case 'docx':
      case 'pdf':
        return '../assets/images/doc.png';

      case 'mp3':
        return '../assets/images/audio.png';

      case 'mp4':
      case 'flv':
      case 'mkv':
      case '3gp':
        return '../assets/images/video.png';

      default:
        return '../assets/images/excel.png';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/buyer/chat-test/chat-test.component.ts